import PropTypes from 'prop-types'
import React, { Component, createRef } from 'react'
import focusable from '../../components/Focusable/Focusable'
import { noOp } from '../../../../shared/helpers'

/**
 * FocusableButton component
 * @deprecated - Use FocusableButtonTS instead on those new components implemented with spatial-navigation
 * @see FocusableButtonTS
 */
class FocusableButton extends Component {
  constructor(props) {
    super(props)
    this.componentType = this.props.componentType
    this.buttonRef = createRef()
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.hasFocus && this.props.hasFocus) {
      this.props.onFocused()
    }
  }

  onKeyEvent(key) {
    const { hasFocus, disabled } = this.props
    if (key === 'ENTER' && hasFocus && !disabled) {
      this.buttonRef.current?.click()
      return true
    }

    return false
  }

  render() {
    const { children, onClick, className, hasFocus, disabled } = this.props

    return (
      <button
        ref={this.buttonRef}
        onClick={onClick}
        disabled={disabled}
        className={`focusable-button ${
          hasFocus && !disabled ? 'focusable-button--focused' : ''
        } ${disabled ? 'focusable-button--disabled' : ''} ${className}`}
      >
        {children}
      </button>
    )
  }
}

FocusableButton.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  onFocused: PropTypes.func,
  className: PropTypes.string,
  hasFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  componentType: PropTypes.string,
}

FocusableButton.defaultProps = {
  children: null,
  onClick: noOp,
  onFocused: noOp,
  className: '',
  hasFocus: false,
  disabled: false,
}

export default focusable(FocusableButton)
